import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller(
            'ChangeContractorEmployeeController',
            ChangeContractorEmployeeController
        );

    /** @ngInject */
    function ChangeContractorEmployeeController(
        $scope,
        $state,
        $stateParams,
        $rootScope,
        CompaniesFactory,
        ngDialog,
        toastr
    ) {
        var vm = this;

        init();

        function init() {
            vm.issue = $scope.ngDialogData.issue;
            vm.addAdditionallyAssignedTo = addAdditionallyAssignedTo;
            vm.removeAdditionallyAssignedTo = removeAdditionallyAssignedTo;
            vm.save = save;

            getContractors();
        }

        function getContractors() {
            CompaniesFactory.getEligibleWorkforce($scope.ngDialogData.company, vm.issue.id).then(function (response) {
                vm.contractorsFromBackend = response.data;
            });
        }

        function refreshIssue(onlySubcontractors) {
            CompaniesFactory.readOneIssue(
                $scope.ngDialogData.company,
                vm.issue.id
            ).then(function (response) {
                if (onlySubcontractors) {
                    vm.issue.additionally_assigned_to =
                        response.data.additionally_assigned_to;
                } else {
                    vm.issue = response.data;
                }
            });
        }

        function addAdditionallyAssignedTo() {
            CompaniesFactory.addAdditionallyAssignedTo(
                $scope.ngDialogData.company,
                $stateParams.issue_id,
                { id: vm.additionallyAssignedToUserId }
            ).then(function () {
                refreshIssue(true);
                toastr.success('Dodano');
            });
        }

        function removeAdditionallyAssignedTo(userId) {
            CompaniesFactory.removeAdditionallyAssignedTo(
                $scope.ngDialogData.company,
                $stateParams.issue_id,
                userId
            ).then(function () {
                refreshIssue(true);
                toastr.success('Usunięto');
            });
        }

        function save() {
            CompaniesFactory.editIssue(
                $scope.ngDialogData.company,
                $stateParams.issue_id,
                { assigned_to: vm.issue.contractor }
            ).then(function (response) {
                $rootScope.$emit('emitThisIssue', response.data);
                toastr.success('Zapisano zmiany');
                ngDialog.close();
                $state.reload('company_employee.issue_list.details');
            });
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/change-contractor-dialog/change-contractor.controller.ts